const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  paper:{
    boxShadow:'none!important',
  },
  table: {
    minWidth: 700,
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/results/views/fiber/styles.js